// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.linkElement {
  display: inline-flex;
  padding: 0 10px 0 0;
}
.linkElement .logo {
  width: 1em;
  height: 1em;
  filter: grayscale(1);
}
@media only screen and (max-width: 670px) {
  .linkElement .logo {
    width: 1.25em;
    height: 1.25em;
  }
}
.linkElement .container {
  display: flex;
  justify-content: right;
  align-items: bottom;
}
.linkElement .subContainer {
  display: none;
  position: fixed;
  margin-top: 1.2em;
  padding-top: 0.8em;
  color: #000;
  z-index: 1;
  text-align: right;
  font-size: 17px;
  border: 1px solid transparent;
}
@media only screen and (max-width: 670px) {
  .linkElement .subContainer {
    padding-top: 1em;
  }
}
.linkElement .item {
  display: inline-block;
}
.linkElement .item a {
  color: black;
  text-decoration: none;
}
@media (hover: none) {
  .linkElement .item a {
    background-color: rgba(255, 255, 255, 0.75);
  }
}
.linkElement .item:hover {
  color: #FFF;
}
.linkElement .logo:hover + .subContainer,
.linkElement .icon:hover + .subContainer {
  display: block;
}
.linkElement .subContainer:hover {
  display: block;
}
.linkElement .name {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: 0.25em;
  color: rgba(0, 0, 0, 0.15);
  cursor: default;
}
.linkElement .icon {
  font-size: 24px;
  color: SteelBlue;
  filter: grayscale(1);
}
@media only screen and (max-width: 670px) {
  .linkElement .icon {
    font-size: 31px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Welcome/MenuLinks/LinkElement.less"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,mBAAA;AACJ;AAHA;EAKQ,UAAA;EACA,WAAA;EACA,oBAAA;AACR;AAEI;EAAA;IAEQ,aAAA;IACA,cAAA;EAAV;AACF;AAdA;EAkBQ,aAAA;EACA,sBAAA;EACA,mBAAA;AADR;AAnBA;EAwBQ,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,6BAAA;AAFR;AAKI;EAAA;IAEQ,gBAAA;EAHV;AACF;AAnCA;EA0CQ,qBAAA;AAJR;AAtCA;EA8CQ,YAAA;EACA,qBAAA;AALR;AAQI;EAAA;IAEQ,2CAAA;EANV;AACF;AA/CA;EAyDQ,WAAA;AAPR;AAlDA;;EA8DQ,cAAA;AARR;AAtDA;EAkEQ,cAAA;AATR;AAzDA;EAsEQ,wCAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;AAVR;AA/DA;EA6EQ,eAAA;EACA,gBAAA;EACA,oBAAA;AAXR;AAcI;EAAA;IAEQ,eAAA;EAZV;AACF","sourcesContent":[".linkElement {\n    display: inline-flex;\n    padding: 0 10px 0 0;\n    \n    .logo {\n        width: 1em;\n        height: 1em;\n        filter: grayscale(1);\n    }     \n\n    @media only screen and (max-width: 670px) {\n        .logo {\n            width: 1.25em;\n            height: 1.25em;\n        }\n    }\n    \n    .container {\n        display: flex;\n        justify-content: right;\n        align-items: bottom;\n    }\n\n    .subContainer {\n        display: none;\n        position: fixed;\n        margin-top: 1.2em;\n        padding-top: .8em;\n        color: #000;\n        z-index: 1;\n        text-align: right;\n        font-size: 17px;\n        border: 1px solid transparent;\n    }\n\n    @media only screen and (max-width: 670px) {\n        .subContainer {\n            padding-top: 1em;\n        }\n    }\n\n    .item {\n        display: inline-block;\n    }\n    \n    .item a {\n        color: black;\n        text-decoration: none;\n    }\n\n    @media (hover: none) {\n        .item a {\n            background-color: rgba(255,255,255, .75);\n        }\n      }\n\n    .item:hover {\n        color: #FFF;\n    }\n  \n    .logo:hover + .subContainer,\n    .icon:hover + .subContainer {\n        display: block;\n    }\n\n    .subContainer:hover {\n        display: block;\n    } \n\n    .name {\n        border-top: 1px solid rgba(0,0,0,.1);\n        margin-top: .25em;\n        color: rgba(0,0,0,.15);\n        cursor: default;\n    }\n\n    .icon {\n        font-size: 24px;\n        color: SteelBlue;\n        filter: grayscale(1);\n    }\n\n    @media only screen and (max-width: 670px) {\n        .icon {\n            font-size: 31px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
